// extracted by mini-css-extract-plugin
export default {"circularProgressInsideAnswers":"SessionView_circularProgressInsideAnswers__k++7f"};